import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export type ContainerSize = "narrow" | "default" | "wide" | "full";

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: ContainerSize;
  children?: ReactNode;
}

export const Container = ({ size = "default", className, children, ...rest }: ContainerProps) => (
  <div className={cn("hui-container", `hui-container--${size}`, className)} {...rest}>
    {children}
  </div>
);
